const ChevronDownIcon = ({ width = 6, height = 4, color = "#737373" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 6 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.00033 3.99975L0.171875 1.17135L1.11469 0.228516L3.00033 2.11415L4.88593 0.228516L5.82873 1.17135L3.00033 3.99975Z"
        fill={color}
      />
    </svg>
  );
};

export default ChevronDownIcon;
